/* eslint-disable no-unused-vars */
import { memo, useContext } from 'react';
import { ManageCampaignsContext } from 'contexts';

const formatDollars = (value) => {
  if (!value) return 0;
  return Number(value || 0).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const formatPercentage = (value) => {
  if (!value) return 0;
  return Number(value).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const CustomPinnedRowRenderer = memo((props) => {
  const isEvent = props.field.includes('events');

  const totalItems = props.data.eventTotalPercents[props.field]?.totalItems;
  const eventPercent = Math.round(
    (props.data.eventTotalPercents[props.field]?.value || 0) / (totalItems === 0 ? 1 : totalItems),
  );

  const calcCPAOfEvents = (eveCount, cost) => {
    let cpa = eveCount > 0 ? cost / eveCount : 0;
    return cpa ? cpa.toFixed(2) : 0;
  };

  const { cpi_campaign_total_cost, cpi_campaign_total_installs } =
    useContext(ManageCampaignsContext);

  const calcConversionRate = (data) => {
    let res = 0;
    if (data.installs > 0 && data.clicks > 0) {
      res = (data.installs / data.clicks) * 100;
    }
    return res.toFixed(2) + '%';
  };

  const calcCTR = (data) => {
    let res = 0;
    if (data.impressions > 0 && data.clicks > 0) {
      res = (data.clicks * 100) / data.impressions;
    }
    return formatPercentage(res) + '%';
  };

  //TO-DO GET avg_cpi from all costs and all installs of cpi campaigns
  const calcAvgCpi = (data) => {
    let res = cpi_campaign_total_installs
      ? cpi_campaign_total_cost / cpi_campaign_total_installs
      : 0;
    return '$' + res.toFixed(2);
  };

  const calcEcpm = (data) => {
    let res = 0;
    if (data.impressions > 100) {
      var ecpm = (data.cost / data.impressions) * 1000;
      res = ecpm;
      if (typeof ecpm === 'number') {
        res = ecpm.toFixed(3);
      }
    }
    return res;
  };

  return (
    <div
      style={{
        height: '100%',
        width: '100%',
        lineHeight: '48px',
        borderLeft: isEvent ? '1px solid #E2E8F0' : '',
      }}
    >
      {props.colDef.colId === 'cost' && `$${formatDollars(props.data[props.field])}`}
      {props.colDef.colId !== 'cr' &&
        props.colDef.colId !== 'ecpm' &&
        props.colDef.colId !== 'ctr' &&
        props.colDef.colId !== 'avg_cpi' &&
        props.colDef.colId !== 'cost' &&
        !isEvent &&
        props.data[props.field]?.toLocaleString()}
      {isEvent && (
        <div style={{ lineHeight: '22px' }}>
          <div>{props.data[props.field]?.toLocaleString()} </div>
          <div>
            ({eventPercent.toLocaleString()}%, $
            {calcCPAOfEvents(props.data[props.field], props.data.cost)})
          </div>
        </div>
      )}
      {props.colDef.colId === 'ctr' && calcCTR(props.data)}
      {props.colDef.colId === 'cr' && calcConversionRate(props.data)}
      {props.colDef.colId === 'ecpm' && calcEcpm(props.data)}
      {props.colDef.colId === 'avg_cpi' && calcAvgCpi(props.data)}
    </div>
  );
});

CustomPinnedRowRenderer.displayName = 'CustomPinnedRowRenderer';
